jQuery(document).ready(function($){
	console.log('Dale Arrangements Theme');
});